module.exports = __webpack_public_path__ + "static/whetstone-9f35d782773987b9ebf0c3132b402ec4.jpg";